import { TProjectWithNationsState } from './types';

export function getListOfProjects(state: TProjectWithNationsState) {
  return state.listOfProjects;
}

export function getProjectsInForeignCountriesDatesCount(state: TProjectWithNationsState) {
  return state.projectsInForeignCountriesDatesCount;
}

export function getIsLoadingCount(state: TProjectWithNationsState) {
  return state.isLoadingCount;
}
